module.exports = __webpack_public_path__ + "img/smallArticleTitle.584aafdd.svg";